module.exports = __webpack_public_path__ + "static/media/arbre-bleu-clair.f37fd404.png";